import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import ChevronSrc from '../../images/chevronBoldBlue.svg';
import Caption from '../Caption';

const Row = styled.a`
  ${tw`inline-flex items-center mb-abs1`}
  text-decoration: none;
`;
const LinkHeader = styled(Caption)`
  ${tw`cursor-pointer hover:underline`}
`;
const Chevron = styled.img`
  transform: rotate(180deg);
  height: 10px;
  width: 10px;
  margin-right: 6px;
`;

const Breadcrumb = ({ path, text }) => (
  <Row href={path}>
    <Chevron alt={text} src={ChevronSrc} />
    <LinkHeader>{text}</LinkHeader>
  </Row>
);

Breadcrumb.propTypes = {
  path: PropTypes.string,
  text: PropTypes.string,
};

export { Breadcrumb };
